import { render, staticRenderFns } from "./OrganismServerManagement.vue?vue&type=template&id=38472c52&scoped=true&"
import script from "./OrganismServerManagement.vue?vue&type=script&lang=js&"
export * from "./OrganismServerManagement.vue?vue&type=script&lang=js&"
import style0 from "./OrganismServerManagement.vue?vue&type=style&index=0&id=38472c52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38472c52",
  null
  
)

export default component.exports